import type { SectionsHeroComponent } from '@twisto/api-cms'

import { CarouselWrapper } from './carousel-wrapper'
import { HeroProvider } from './hero-provider'
import { CenteredTransparent } from './hero-variants'

const getSliderContent = ({
  slider,
  currentActiveVariant,
  sliderCompact,
  centered,
  staticTransparent,
}: SectionsHeroComponent) => {
  switch (currentActiveVariant) {
    case 'sliderCompact':
      return sliderCompact
    case 'centered':
      return centered
    case 'staticTransparent':
      return staticTransparent
    default:
      return slider
  }
}

export const Hero = ({
  slider,
  staticTransparent,
  centeredTransparent,
  currentActiveVariant,
  download,
  promo,
  sliderCompact,
  centered,
}: SectionsHeroComponent) => {
  if (!currentActiveVariant) {
    return null
  }

  const renderCurrentVariant = () => {
    switch (currentActiveVariant) {
      case 'centeredTransparent':
        return <CenteredTransparent {...centeredTransparent} />
      default:
        return (
          <CarouselWrapper
            hideControls={currentActiveVariant === 'sliderCompact'}
          />
        )
    }
  }

  return (
    <HeroProvider
      value={{
        download,
        promo,
        currentActiveVariant,
        slider: getSliderContent({
          slider,
          currentActiveVariant,
          sliderCompact,
          centered,
          staticTransparent,
        }),
      }}
    >
      {renderCurrentVariant()}
    </HeroProvider>
  )
}
